export default {
    SuperAdmin: 'Super Administrator',
    Admin: 'IAM Admin',
    Editor: 'IAM Editor',
    Viewer: 'IAM Viewer'
}